<template>
    <div>
        <div class="container">
            <div class="handle-box">
                <!-- <el-select
                v-model="code_id"
                class="handle-select mr10"
                @change="handleSelectChange"
                >
                    <el-option
                        v-for="(child, index) in code_ids"
                        :key="index"
                        :label="child.name"
                        :value="child.id"
                    ></el-option>
                </el-select> -->
                <el-input v-model="keyword" placeholder="请输入手机号" class="handle-input mr10"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                v-loading="loading"
            >
                <el-table-column label="序号" align="center" width="50">
                    <template slot-scope="scope">
                        <span>{{scope.$index+1+page_index}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="sign_name" label="渠道" align="center"></el-table-column>
                <el-table-column prop="phone" label="手机号" align="center"></el-table-column>
                <el-table-column prop="send_count" label="发送次数" align="center"></el-table-column>
                <el-table-column prop="send_date" label="发送日期" align="center">
                    <template slot-scope="scope">
                        {{formatDate(scope.row.send_date)}}
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination" v-if="totalPages > 1">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :current-page="currentPage"
                    :page-size="page_size"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import http from '../../../../api/smsApiConfig'
export default {
    name: 'Msgsend',
    data() {
        return {
            code_ids: [
                {"name": "家庭中医馆", "id": 'medicine_login'}
            ],
            code_id: 'medicine_login',
            tableData: [],
            currentPage: 1,
            totalPages: 1,
            page_size: 10,
            pageTotal: 10,
            page_index: 10,
            keyword: '',
            loading: false
        };
    },
    created() {
        this.getData();
    },
    methods: {
        formatDate(date){
            return new Date(date).Format('YYYY-MM-DD');
        },
        getData() {
            let that = this;
            that.loading = true;
            let params = {
                page: that.currentPage,
                page_size: that.page_size
            }
            params["phone"] = that.keyword;
            // params["code"] = that.code_id;
            http.get("/admin/sms_counts",{params: params}).then(function(res) {
                that.page_index = (that.currentPage - 1) * that.page_size;
                that.tableData = res.data.data.sms_counts;
                that.currentPage = parseInt(res.data.data.current_page);
                that.totalPages = res.data.data.total_pages;
                that.pageTotal = that.totalPages * that.page_size;
                that.loading = false;
            });
        },
        handleSelectChange(){
            this.currentPage = 1;
            this.getData();
        },
        // 触发搜索按钮
        handleSearch() {
            this.currentPage = 1;
            this.getData();
        },
        handlePageChange(val) {
            this.currentPage = val;
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
